import { render, staticRenderFns } from "./FeedHeader.vue?vue&type=template&id=b8b0da0c&"
import script from "./FeedHeader.vue?vue&type=script&lang=js&"
export * from "./FeedHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/devteam/projects/dominion-conference-app/ConferenceAdmin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports